export default "__VITE_ASSET__C9EBbD2D__"